// @flow
import $ from 'jquery'
import _ from 'lodash'
import React, { Component } from 'react'
import FloatHeader from '../main/legacy/TableFloatHeader'
import FloatFooter from '../main/legacy/TableFloatFooter'
import Row from './AdvertisementsTable/Row'
import Thead from './AdvertisementsTable/Thead'
import Tfoot from './AdvertisementsTable/Tfoot'
import FilterForm from './AdvertisementsTable/FilterForm'
import styled, { type StyledComponent } from 'styled-components'
import { Table, Link, BodyRow, Cell } from './MainTable'
import MassOperationsFooter from './controls/MassOperationsFooter'
import Checkbox from './controls/Checkbox'
import type { OptionType } from './types'

const EmptyRow: StyledComponent<Object, any, any> = styled(BodyRow)`
  height: 20px;
`
const Wrapper: StyledComponent<Object, any, any> = styled.div`
  overflow: auto;
`

const STATISTICS_TYPE_KEY = 'advert-statistics-type'
const ROW_LENGTH = 14

const activateUrl = '/api/v1/advertisement_statuses/activate'
const deactivateUrl = '/api/v1/advertisement_statuses/deactivate'
const archiveUrl = '/api/v1/advertisement_statuses/archive'

type AdvertisementPaths = {|
  editPath: string,
  copyPath: string,
  detachFromTemplateUrl: string
|}

type ProviderState = {|
  state: string,
  description: string,
  activateUrl: string,
  deactivateUrl: string
|}

type ProviderStates = {|
  [string]: ProviderState
|}

type ProviderStatusesProperties = {|
  rejectedStateConstant: string,
  noBudgetStateConstant: string,
  suspendedStateConstant: string,
  unconnectedStateConstant: string,
  errorStateConstant: string,
  isActive: boolean,
  isAudiencePaused: boolean,
  isAudienceInactive: boolean,
  isAudienceComplete: boolean,
  noBudgetHelpPath: string,
  editPath: string,
  connectPath: string,
  providerStates: ProviderStates,
  decorateHumanDescription: string,
  hidePlayPauseButtons: boolean
|}

export type AdvertisementStatistics = {|
  advertisementId?: number,
  clicks: string,
  counterImpressions: string,
  cpc?: string,
  cpm?: string,
  ctr?: string,
  goalPercentage?: string,
  goalPrice?: string,
  goals: string,
  impressions: string,
  providerName: string,
  spent: string
|}

export type Advertisement = {|
  id: number,
  paths: AdvertisementPaths,
  provider_statuses_properties: ProviderStatusesProperties,
  statusesProps: ProviderStatusesProperties,
  active: boolean,
  checked: boolean,
  providers_list: Array<string>,
  picture: any,
  url: string,
  title: string,
  description: string,
  advertisement_template_id: number,
  advertisement_template_name: string,
  advertisement_name: string
|}

export type TableItem = {|
  audienceId: number,
  audienceName: string,
  audienceEditPath: string,
  campaignId: number,
  campaignName: string,
  isProductRetargeting: boolean,
  isPostsPromotion: boolean,
  advertisements: Array<Advertisement>
|}

type Props = {|
  initialTableItems: Array<TableItem>,
  tableItems: Array<TableItem>,
  datepicker: string,
  newAdvertisementPath: string,
  statisticsPath: string,
  sortField: string,
  sortDirection: string,
  dateSeparator: string,
  filterFormOrigin: string,
  providersList: Array<string>,
  isFilterFormChanged: boolean,
  visibleTableItems: Array<TableItem>,
  archivedAdvertisementIds: Array<number>,
  detachedAdvertisementIds: Array<number>,
  checkedAdvertisementIds: Array<number>,
  isLoading: boolean,
  statistics: Array<AdvertisementStatistics>,
  adStatistics: { [number]: Array<AdvertisementStatistics> },
  statisticsType: string,
  selectedAdvertisementTemplateIds: Array<number>,
  advertisementTemplateOptions: Array<OptionType>,
  isImportedAudience: boolean,
  onChange: Function
|}

export default class AdvertisementsTable extends Component<Props> {
  table: any
  tableWrapper: any
  floatHeader: any
  floatFooter: any

  constructor(props: Props) {
    super(props)

    const providersList = _(props.initialTableItems)
      .map('advertisements')
      .flatten()
      .map('providers_list')
      .flatten()
      .uniq()
      .sort()
      .value()

    let storeState: Object = {
      providersList,
      sortField: props.sortField || '',
      sortDirection: props.sortDirection || '',
      statistics: props.statistics
    }

    const statisticsTypeFromCookies = window.Cookies.get(STATISTICS_TYPE_KEY)
    // protection from bad cookie value
    // is case of it, set 'overall' by default
    if (_.includes(['divided', 'overall', ...providersList], statisticsTypeFromCookies)) {
      storeState.statisticsType = statisticsTypeFromCookies
    } else {
      storeState.statisticsType = 'overall'
    }
    props.onChange({
      ...storeState,
      isFilterFormChanged: false,
      isLoading: false,
      tableItems: props.initialTableItems.map((item) => {
        return {
          ...item,
          advertisements: _.map(item.advertisements, (ad) => {
            const { provider_statuses_properties: statusesProps, ...other } = ad
            return { ...other, statusesProps }
          })
        }
      }),
      advertisementTemplateOptions: this.advertisementTemplateOptions(props.initialTableItems)
    })
  }

  componentDidMount() {
    const $table = $(this.table)
    const $wrapper = $(this.tableWrapper)

    this.floatHeader = new FloatHeader($table, $wrapper) // eslint-disable-line no-new
    this.floatFooter = new FloatFooter($table, $wrapper) // eslint-disable-line no-new
  }

  componentDidUpdate() {
    this.floatHeader.refresh()
    this.floatFooter.refresh()
  }

  render() {
    const {
      datepicker,
      statisticsPath,
      newAdvertisementPath,
      dateSeparator,
      filterFormOrigin
    } = this.props
    return (
      <Wrapper>
        <FilterForm
          cookieStatisticsTypeKey={STATISTICS_TYPE_KEY}
          loadStatisticsPath={statisticsPath}
          newAdvertisementPath={newAdvertisementPath}
          datepicker={datepicker}
          dateSeparator={dateSeparator}
          filterFormOrigin={filterFormOrigin}
          onChange={(isFilterFormChanged) => this.props.onChange({ isFilterFormChanged })}
          selectedAdvertisementTemplateIds={this.props.selectedAdvertisementTemplateIds}
          advertisementTemplateOptions={this.props.advertisementTemplateOptions}
          isImportedAudience={this.props.isImportedAudience}
          onSelectedAdvertisementTemplateIdsChange={(ids) =>
            this.props.onChange({ selectedAdvertisementTemplateIds: ids })
          }
        />
        <div
          ref={(el) => {
            this.tableWrapper = el
          }}
        >
          <Table
            ref={(el) => {
              this.table = el
            }}
            className="t-AdvertisementTable"
            style={{ opacity: this.props.isFilterFormChanged ? 0.5 : 1 }}
          >
            <Thead />
            <tbody>
              {this.props.visibleTableItems.map((item, index) => [
                index !== 0 && this.renderEmptyRow(),
                this.renderTableItemRows(item, index === 0)
              ])}
            </tbody>
            <Tfoot
              adStatistics={this.props.adStatistics}
              providersList={this.props.providersList}
              statisticsType={this.props.statisticsType}
            />
          </Table>
          {!_.isEmpty(this.props.checkedAdvertisementIds) && this.renderFooter()}
        </div>
      </Wrapper>
    )
  }

  renderEmptyRow() {
    return (
      <EmptyRow key={0}>
        <td colSpan={ROW_LENGTH} />
      </EmptyRow>
    )
  }

  renderTableItemRows(item: TableItem, isFirstItem: boolean) {
    return [this.renderAudienceRow(item, isFirstItem), this.renderAdvertisementRows(item)]
  }

  renderAudienceRow(item: TableItem, isFirstItem: boolean) {
    return (
      <BodyRow key={`audience_${item.audienceId}`} topShadow={!isFirstItem}>
        <Cell>
          <Checkbox
            onChange={(checked) =>
              this.advertisementCheckboxChange(checked, _.map(item.advertisements, 'id'))
            }
            checked={_.every(item.advertisements, (ad) =>
              _.includes(this.props.checkedAdvertisementIds, ad.id)
            )}
          />
        </Cell>
        <Cell colSpan={ROW_LENGTH}>
          <div className="t-AdvertisementName">{item.campaignName}</div>
          <div>
            <Link href={item.audienceEditPath} className="offable">
              {item.audienceName}
            </Link>
          </div>
        </Cell>
      </BodyRow>
    )
  }

  renderAdvertisementRows(item: TableItem): Array<any> {
    return _.map(item.advertisements, (advertisement: Advertisement) => {
      const { id } = advertisement
      const statistics = this.props.adStatistics[id]
      return (
        <Row
          key={id}
          isProductAudience={item.isProductRetargeting}
          isPromotionAudience={item.isPostsPromotion}
          onArchive={() => this.advertisementArchived(id)}
          onArchivationRollback={() => this.advertisementArchivationFailed(id)}
          onDetachFromTemplate={() => this.detachedFromTemplate(id)}
          onAdvertisementCheckboxChange={(checked) =>
            this.advertisementCheckboxChange(checked, [id])
          }
          onAdvertisementStateChange={(data) => this.updateAdvertisementState(data, [id])}
          advertisementCheckboxChecked={this.isAdvertisementCheckboxChecked(id)}
          activateUrl={activateUrl}
          deactivateUrl={deactivateUrl}
          archiveUrl={archiveUrl}
          advertisement={advertisement}
          statistics={statistics}
          campaignName={item.campaignName}
          audienceName={item.audienceName}
          audienceEditPath={item.audienceEditPath}
        />
      )
    })
  }

  advertisementArchived(id: number) {
    this.props.onChange({
      archivedAdvertisementIds: _.concat(this.props.archivedAdvertisementIds, id)
    })
  }

  advertisementArchivationFailed(id: number) {
    this.props.onChange({
      archivedAdvertisementIds: _.without(this.props.archivedAdvertisementIds, id)
    })
  }

  detachedFromTemplate(id: number) {
    this.props.onChange({
      detachedAdvertisementIds: _.concat(this.props.detachedAdvertisementIds, id)
    })
  }

  isAdvertisementCheckboxChecked(id: number) {
    return _.includes(this.props.checkedAdvertisementIds, id)
  }

  advertisementCheckboxChange(checked: boolean, ids: Array<number>) {
    const { checkedAdvertisementIds, onChange } = this.props

    if (checked) {
      onChange({ checkedAdvertisementIds: checkedAdvertisementIds.concat(...ids) })
    } else {
      onChange({ checkedAdvertisementIds: _.without(checkedAdvertisementIds, ...ids) })
    }
  }

  renderFooter() {
    return (
      <MassOperationsFooter
        isLoading={this.props.isLoading}
        activateUrl={activateUrl}
        deactivateUrl={deactivateUrl}
        archiveUrl={archiveUrl}
        ids={this.props.checkedAdvertisementIds}
        onBeforeRequest={() => this.props.onChange({ isLoading: true })}
        onAfterRequest={() => this.props.onChange({ isLoading: false })}
        onActivateDeactivateSuccess={(data, ids) => this.updateAdvertisementState(data, ids)}
        onArchiveSuccess={() => this.onArchiveSuccess()}
      />
    )
  }

  updateAdvertisementState(data: Array<Object>, ids: Array<number>) {
    const newTableItems = _.map(this.props.tableItems, (item) => {
      const newAdvertisements = _.clone(item.advertisements)

      _.each(newAdvertisements, (advertisement, index: number) => {
        if (_.includes(ids, advertisement.id)) {
          const responseStateData = _.find(data, (responseState) => {
            return responseState.id === advertisement.id
          })
          if (responseStateData) {
            newAdvertisements[index] = {
              ...advertisement,
              active: responseStateData.active,
              statusesProps: responseStateData.provider_statuses,
              checked: responseStateData.state
            }
          }
        }
      })
      return { ...item, advertisements: newAdvertisements }
    })
    this.props.onChange({ tableItems: newTableItems })
  }

  onArchiveSuccess() {
    const { checkedAdvertisementIds, archivedAdvertisementIds, onChange } = this.props
    onChange({
      archivedAdvertisementIds: archivedAdvertisementIds.concat(checkedAdvertisementIds),
      checkedAdvertisementIds: []
    })
  }

  advertisementTemplateOptions(items: Array<TableItem>): Array<OptionType> {
    return _.uniqBy(
      _.flatMap(items, (item) => {
        return _.map(
          _.filter(item.advertisements, (ad) => {
            return !_.isEqual(ad.advertisement_template_id, null)
          }),
          (ad) => {
            return {
              id: ad.advertisement_template_id,
              name: `[#${ad.advertisement_template_id}] ${ad.advertisement_template_name}`
            }
          }
        )
      }),
      'id'
    )
  }
}
